var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2.472 2.472c.63-.63 1.652-.63 2.281 0L12 9.72l7.247-7.247a1.613 1.613 0 0 1 2.28 2.281L14.282 12l7.247 7.247a1.613 1.613 0 1 1-2.281 2.28L12 14.282l-7.247 7.247a1.613 1.613 0 1 1-2.28-2.281L9.718 12 2.472 4.753a1.613 1.613 0 0 1 0-2.28",
    clipRule: "evenodd"
  })));
};
export default SvgClose;